import React from 'react';
import { ClipboardCheckIcon, FootprintsIcon, ClockIcon, GaugeIcon, ImageIcon, CalendarCheckIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: ClipboardCheckIcon,
  color: 'text-brand'
}, {
  Icon: FootprintsIcon,
  color: 'text-goldDark'
}, {
  Icon: ClockIcon,
  color: 'text-check'
}, {
  Icon: GaugeIcon,
  color: 'text-brand'
}, {
  Icon: ImageIcon,
  color: 'text-goldDark'
}, {
  Icon: CalendarCheckIcon,
  color: 'text-navy'
}];
export function BenefitsGrid() {
  return <section className="bg-pale px-4 py-6 text-center md:px-12 md:py-8" data-id="element-1" data-mp="ex1xopd34eyr">
      <h2 className="mx-auto max-w-[620px] font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[26px]" data-id="element-2" data-mp="9y7idxebt8je">
        This isn't another aqua fitness ebook filled with theory.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] font-heading text-[13px] font-bold uppercase leading-tight text-brand md:text-[16px]" data-id="element-3" data-mp="3w4nn3agskria">
        It's a complete collection of practical, ready-to-teach classes.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-4" data-mp="26q4seo9fkhhj">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i];
        const isLastOdd = i === benefits.length - 1 && benefits.length % 2 === 1;
        return <article key={b.title} className={`flex gap-2.5 rounded-md border border-line bg-white p-3 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-5" data-mp="21rteo2g0lmu1" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-6" data-mp="2ugs2ng6tjj79" />
              <div data-id="element-7" data-mp="2ghscg43nqw8z">
                <h3 className="font-heading text-[14px] font-bold leading-tight text-navy md:text-[15px]" data-id="element-8" data-mp="2gg7juk0wlndr">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-ink md:text-[14px]" data-id="element-9" data-mp="2kh9k946k45hb">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
      <p className="mt-3.5 font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-10" data-mp="193xlv8tkgf2j">
        Everything organized in one professional collection.
      </p>
    </section>;
}